module.exports = __webpack_public_path__ + "img/case-logo-33.3a566227.png";